/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckylottery.vue?vue&type=template&id=da424004&scoped=true"
import script from "./popLuckylottery.vue?vue&type=script&lang=js"
export * from "./popLuckylottery.vue?vue&type=script&lang=js"
import style0 from "./popLuckylottery.vue?vue&type=style&index=0&id=da424004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da424004",
  null
  
)

export default component.exports